import { prevent } from '../../../../common/utils';
export function useKeys(state, props) {
    var time = props.time;
    var setFocus = state.setFocus, isReadonly = state.isReadonly, isDisabled = state.isDisabled;
    function onKeyUp(event, input) {
        if (event.key === Keys.ArrowLeft) {
            if (input === 'm')
                prevent(event) && setFocus('d');
            else if (input === 'y')
                prevent(event) && setFocus('m');
            else if (input === 'h')
                time && prevent(event) && setFocus('y');
            else if (input === 'i')
                time && prevent(event) && setFocus('h');
        }
        else if (event.key === Keys.ArrowRight) {
            if (input === 'd')
                prevent(event) && setFocus('m');
            else if (input === 'm')
                prevent(event) && setFocus('y');
            else if (input === 'y')
                time && prevent(event) && setFocus('h');
            else if (input === 'h')
                time && prevent(event) && setFocus('i');
        }
        else if (event.key !== Keys.ArrowUp && event.key !== Keys.ArrowDown) {
            var value = String(event.target['value'] || '');
            if (input === 'd' && value.length === 2)
                prevent(event) && setFocus('m');
            else if (input === 'm' && value.length === 2)
                prevent(event) && setFocus('y');
            else if (input === 'y' && value.length === 4)
                time && prevent(event) && setFocus('h');
            else if (input === 'h' && value.length === 2)
                time && prevent(event) && setFocus('i');
        }
    }
    return {
        onKeyUpDay: function (e) { return onKeyUp(e, 'd'); },
        onKeyUpMonth: function (e) { return onKeyUp(e, 'm'); },
        onKeyUpYear: function (e) { return onKeyUp(e, 'y'); },
        onKeyUpHour: function (e) { return onKeyUp(e, 'h'); },
        onKeyUpMinute: function (e) { return onKeyUp(e, 'i'); },
    };
}
